/**
 * The dungeon's band at the top of the screen (integration plan slice 4,
 * drawn the retro way since slice 6b): the status line, the collapsed log and
 * the help line in one `corner` panel (a grid whose areas change with the
 * orientation), and beside it whatever `aside` holds (the minimap, with its own
 * panel edge). The menu button sits in the corner to its right, outside this
 * element. The band stays within 15% of the viewport height (the ui AGENTS
 * rule); the touch pad sits in the bottom corners, outside it. A walkable
 * scene has no band: only the menu button, the prompt and the location name.
 */
import type { ReactNode } from 'react';
import { Panel } from './panel.tsx';
import './ui.css';

export const Hud = ({ children, aside }: { readonly children: ReactNode; readonly aside?: ReactNode }) => (
  <div className="ab-hud" data-testid="hud">
    <Panel placement="corner" className="ab-band" data-testid="band">
      {children}
    </Panel>
    {aside}
  </div>
);
